/**Import react section */
import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import moment from 'moment'
/**Import Material UI section */
import { Stepper, Step, StepLabel, Typography, StepContent, Grid, makeStyles } from '@material-ui/core'
/**Import Components section */
import ButtonSaved from '../../common/Buttons/ButtonSaved'
import TextBox from '../../common/TextBox'

/**Import Helper section */
import { toSafeObject } from '../../../store/helpers/StateHelper'
import { containsHtmlContent, stripHtmlTags } from '../../../store/helpers/StringHelper'
import ConfirmCommentHistoryUpdateDialog from './ConfirmCommentHistoryUpdateDialog'

const useStepIconStyles = makeStyles((theme) => ({
	customStepIcon: {
		backgroundColor: theme.palette.grey[400],
		color: theme.palette.common.white,
		width: 24,
		height: 24,
		borderRadius: '50%',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		fontSize: '0.75rem',
		fontWeight: 'bold'
	},
	active: {
		backgroundColor: theme.palette.primary.main
	},
	completed: {
		backgroundColor: theme.palette.primary.main
	}
}))
const CustomStepIcon = (props) => {
	const classes = useStepIconStyles()
	const { active, completed, icon } = props
	const totalSteps = props.totalSteps || 1
	const index = Number(icon) - 1
	const reversedNumber = totalSteps - index

	return <div className={`${classes.customStepIcon} ${active ? classes.active : ''} ${completed ? classes.completed : ''}`}>{reversedNumber}</div>
}
const TimeLineCommentHistory = (props) => {
	const { serviceToken, onUpdateCommentHistory, onUpdateComment, isAuthorizedForChangingStatus, isAuthorizedForCreatingComment } = props
	const [activeStep, setActiveStep] = useState(0)
	const [commentsHistoriesList, setCommentsHistoriesList] = useState([])
	const [isOpenModal, setIsOpenModal] = React.useState(false)
	const [commentsToken, setCommentsToken] = React.useState('')

	useEffect(() => {
		setCommentsHistoriesList(props.commentsHistory)
	}, [props.commentsHistory])

	const [activeComment, setActiveComment] = useState('')
	const internalUsers = useSelector((state) => toSafeObject(state.users.get('internalUsers')))

	const onClickShowItem = (event, stepNumber) => {
		event.stopPropagation()
		setActiveStep((prevActiveStep) => stepNumber)
		setActiveComment(commentsHistoriesList[stepNumber].Comments)
	}

	const onSaveStatus = (commentToken) => {
		if (onUpdateCommentHistory) {
			onUpdateCommentHistory(serviceToken, commentToken)
			let newCommentsList = commentsHistoriesList.map((c) => {
				if (c.Token === commentToken) {
					c.Status = 2
				}
				return c
			})
			setCommentsHistoriesList(newCommentsList)
		}
	}

	const onChangeComment = (event, commentToken) => {
		event.stopPropagation()
		let newCommentValue = event.target.value
		let newCommentsList = commentsHistoriesList.map((c) => (c.Token === commentToken ? { ...c, Comments: newCommentValue } : c))
		setActiveComment(newCommentValue)
		setCommentsHistoriesList(newCommentsList)
	}

	const onSaveComment = (event, commentToken) => {
		if (onUpdateComment) {
			onUpdateComment(serviceToken, commentToken, activeComment)
		}
	}
	const onOpenModal = (event, commentToken) => {
		setIsOpenModal(!isOpenModal)
		setCommentsToken(commentToken)
	}

	const onCloseModal = () => {
		setIsOpenModal(false)
	}

	const onSaveCommentFromModal = () => {
		if (onUpdateComment) {
			onUpdateComment(serviceToken, commentsToken, activeComment)
		}
	}

	return (
		<div>
			{commentsHistoriesList !== null ? (
				<Typography variant='h6'>Comments history</Typography>
			) : (
				<Typography variant='h6'>There are no comments in the history to show</Typography>
			)}
			{commentsHistoriesList !== null && (
				<Stepper activeStep={activeStep} orientation='vertical' style={{ margin: 0, padding: 0 }}>
					{commentsHistoriesList.map((commentHistoryItem, index) => {
						let nameOfUser = commentHistoryItem.CreatorUser ? internalUsers.find((x) => x.UserName === commentHistoryItem.CreatorUser.UserName)?.Name : ''
						let statusText = commentHistoryItem.Status
							? commentHistoryItem.Status === 2
								? 'Published'
								: commentHistoryItem.Status === 1
									? 'In Process'
									: 'Undefined'
							: 'Undefined'
						let enableActions = commentHistoryItem.Status === 1 && index === activeStep && isAuthorizedForChangingStatus
						let activateComments = index === activeStep && isAuthorizedForChangingStatus
						let activateCommentsRepSales = index === activeStep
						let safeComments = containsHtmlContent(commentHistoryItem.Comments)
							? stripHtmlTags(commentHistoryItem.Comments)
							: commentHistoryItem.Comments
						return isAuthorizedForCreatingComment || commentHistoryItem.Status === 2 ? (
							<Step key={index}>
								<StepLabel
									StepIconComponent={(iconProps) => <CustomStepIcon {...iconProps} totalSteps={commentsHistoriesList.length} />}
									onClick={(event) => onClickShowItem(event, index)}
								>
									{!enableActions && (
										<div style={{ width: '100%' }}>
											{index === activeStep ? (
												<Typography variant='body1' style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
													{commentHistoryItem.CreationType === 1 && commentHistoryItem.CreatorUser.Account.Name !== 'KONOP'
														? `${moment(commentHistoryItem.CreationDate).format('MMM DD, YYYY - MM/D')}- ${safeComments}`
														: `${safeComments}`}
												</Typography>
											) : (
												<Typography
													variant='body1'
													style={{ overflow: 'hidden', textOverflow: 'ellipsis', width: '640px', whiteSpace: 'nowrap' }}
												>
													{commentHistoryItem.CreationType === 1 && commentHistoryItem.CreatorUser.Account.Name !== 'KONOP'
														? `${moment(commentHistoryItem.CreationDate).format('MMM DD, YYYY - MM/D')}- ${safeComments}`
														: `${safeComments}`}
												</Typography>
											)}
										</div>
									)}
									{(activateComments || activateCommentsRepSales) && (
										<Grid item xs={12}>
											<br />
											<TextBox
												active={true}
												fullWidth
												name='comments'
												variant='outlined'
												margin='dense'
												label='COMMENTS'
												multiline
												rows={3}
												autoFocus
												onChange={(event) => onChangeComment(event, commentHistoryItem.Token)}
												value={activeComment ? activeComment : ''}
												disabled={!isAuthorizedForCreatingComment}
											/>
										</Grid>
									)}
									<Grid
										item
										xs={12}
										style={{
											display: 'flex',
											justifyContent: 'flex-end'
										}}
									>
										{isAuthorizedForCreatingComment && (activateComments || activateCommentsRepSales) && (
											<ButtonSaved
												title='Save'
												onSavedClick={
													index === 0
														? (event) => onOpenModal(event, commentHistoryItem.Token)
														: (event) => onSaveComment(event, commentHistoryItem.Token)
												}
											/>
										)}
									</Grid>
								</StepLabel>
								<StepContent>
									<Typography color='textSecondary' variant='caption'>{`${statusText} - ${moment(commentHistoryItem.CreationDate).format(
										'MM/DD/YYYY'
									)}`}</Typography>
									<br />
									<Typography color='textSecondary' variant='caption'>
										{nameOfUser ? nameOfUser : commentHistoryItem.CreatorUser.UserName}
									</Typography>
									<br />
									{commentHistoryItem.Status === 1 && index === activeStep && <br />}
									{enableActions && <ButtonSaved title='Published' onSavedClick={(event) => onSaveStatus(commentHistoryItem.Token)} />}
								</StepContent>
							</Step>
						) : (
							<></>
						)
					})}
				</Stepper>
			)}
			<ConfirmCommentHistoryUpdateDialog open={isOpenModal} onClose={onCloseModal} onSaveCommentFromModal={onSaveCommentFromModal} />
		</div>
	)
}

export default TimeLineCommentHistory
